import { useTranslation } from "react-i18next";
import Button from "src/SharedComponents/Button/Button";
import PopupDialog from "src/SharedComponents/PopupDialog/PopupDialog";
import tableStyles from 'src/Utils/CssModules/table.module.css';
import { IClinic } from "src/Utils/Hooks/useGetDistributorInfo/useGetDistributorInfo";
import { CloseIcon } from 'src/SharedComponents/Icons/Icons';
import './AssignDeviceToClinic.css';
import { formatDateString } from "src/Utils/DateFormatting/DateFormattter";
import SearchBar from "src/SharedComponents/SearchBar/SearchBar";
import { useRef, useState } from "react";
import useSortableData, { SortConfig } from "src/Utils/Hooks/SortableData/useSortableData ";
import TableHead from "src/SharedComponents/Table/TableHead";
import { useSearch } from "src/Utils/Hooks/SearchData/useSearch";
export interface IAssignDeviceToClinic {
    onClose: () => void,
    clinics: IClinic[],
    serialNumber: string;
    onSubmit: (clinicID: string, clinicName: string) => void;
}
const AssignDeviceToClinic: React.FC<IAssignDeviceToClinic> = ({ onClose, onSubmit, clinics, serialNumber }) => {
    const { t } = useTranslation();

    let conf: SortConfig<IClinic> = {
        key: 'name',
        direction: 'ascending'
    };
    
    const [searchText, setSearchText] = useState<string>('');
    const searchKeys = useRef<(keyof IClinic)[]>(['name'])
    const filteredClinics = useSearch(clinics, searchText, searchKeys.current);
    const { items, requestSort, sortConfig } = useSortableData(filteredClinics, conf);

    return (
        <>
        <div className="assignToClinic">
            <PopupDialog onClose={() => onClose()}>
                <div className="assign-device-header d-flex flex-column row">
                    <div className="d-flex justify-content-between align-items-center">
                        {/* Figma draws dialog titles at 20/600 — the same scale as
                            Modal.header and the confirm dialogs — not 24px. */}
                        <span style={{ fontWeight: 'var(--font-weight-semibold)', fontSize: 'var(--font-size-lg)' }}>{t('AssignDevice', { 'serialNumber': serialNumber })}</span>
                        <i style={{ cursor: 'pointer' }} onClick={() => { onClose() }}>
                            <CloseIcon />
                        </i>
                    </div>
                    <div className="row ps-4 ds-text-base ds-text-primary ds-font-regular">
                        {t('SelectAClinic')}
                    </div>
                    <div className="row mt-2">
                        <SearchBar onChange={(text:string) => {setSearchText(text) }} />
                    </div>
                </div>
                <div className="table-responsive" style={{overflowX:"hidden", borderRadius:'20px', marginBottom:'2px'}}>
                 <table data-testid="table" className={`table ${tableStyles.tableStriped}`}>
                        <thead className={`${tableStyles.tableHead}`}>
                            <tr key={'header'}>
                                <TableHead<IClinic>
                                    columnName={t('ClinicName')} 
                                    paddingLeft="25px"
                                    requestSort={requestSort}
                                    sortConfig={sortConfig}
                                    columnkey="name"
                                />
                                <TableHead<IClinic>
                                    columnName={t('SetupDate')} 
                                    requestSort={requestSort}
                                    sortConfig={sortConfig}
                                    columnkey="setUpDate"
                                />
                                 <th className={tableStyles.heading}>{ }</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((clinic, i) => (
                                <tr key={i}>
                                    <td className={tableStyles.data} style={{width:"39%", paddingLeft:'25px' }}>
                                        {clinic.name}
                                    </td>
                                    <td className={tableStyles.data} style={{width:"39%"}}>
                                        {formatDateString(clinic.setUpDate)}
                                    </td>
                                    <td className={tableStyles.data} style={{ fontWeight: 600}}>
                                        <Button
                                            backgroundColor="var(--primary-color)"
                                            color="white"
                                            text={t("Assign")}
                                            borderColor="none"
                                            fontSize="12px"
                                            width='127px'
                                            onClick={() => { onSubmit(clinic.clinicId, clinic.name) }}
                                        />
                                    </td>

                                </tr>
                            ))}
                           
                        </tbody>
                    </table>
                </div>
            </PopupDialog>
        </div>
        </>
    )
}
export default AssignDeviceToClinic;